import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser } from "slices/thunk";
import { Navigate } from "react-router-dom";
import { RootState } from "slices";
import { createSelector } from 'reselect';
import { WithAuthProps } from "Common/Components/Authentication/WithAuthProps";
import withAuth from '../../Common/Components/Authentication/withAuth';

interface selectLogoutState {
    isUserLogout: boolean;
}

const Logout: React.FC<WithAuthProps> = ({
    account
}) => {

    const handleLogout = () => {
        account.logout();
        //window.location.href = "/login";
    }

    useEffect(() => {
        handleLogout();
    }, []);

    return <Navigate to="/login" />
}

export default withAuth(Logout);
